import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { type TGetSelfResponse } from '../types/MerchantTypes';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export const TraderApi = createApi({
  reducerPath: 'TraderApi',
  tagTypes: ['Merchant'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getSelf: build.query<TGetSelfResponse, void>({
      query: () => ({
        url: '/merchant/get_self/',
        method: 'GET',
      }),
      providesTags: [{ type: 'Merchant', id: 'LIST' }],
      transformErrorResponse: (response: any) => {
        if (response.status === 401) {
          window.location.href = '/';
          localStorage.removeItem('token');
        }
      },
      transformResponse: (response: TGetSelfResponse) => {
        if (!response) {
          window.location.href = '/';
          localStorage.removeItem('token');
        }
        return response;
      },
    }),
  }),
});

export const { useGetSelfQuery } = TraderApi;
